import { getPercent } from "@helpers";
import { SecuritiesChartDataWithDate } from "@components/Chart";

export const calculatePercentsForPerformance = (
  data: SecuritiesChartDataWithDate[],
  isComparison = false
) => {
  let reference = data[0];
  let comparedValue = 1;

  return data.map((current) => {
    const step = {
      ...current,
      totalValue: getPercent(current.totalValue),
      holdingsValue: getPercent(current.holdingsValue),
      fondsValue: getPercent(current.fondsValue),
      etfsValue: getPercent(current.etfsValue),
      derivativeValue: getPercent(current.derivativeValue),
      bondsValue: current.bondsValue
        ? getPercent(current.bondsValue)
        : current.bondsValue,
      areaValue: [
        getPercent(current.areaValue[0]),
        getPercent(current.areaValue[1]),
      ] as [number, number],
    };

    if (isComparison) {
      const currentCompared = current.comparedValue ?? 0;
      const referenceCompared = reference.comparedValue ?? 0;
      if (current.comparedValue && reference.comparedValue) {
        comparedValue *= currentCompared / referenceCompared;
      }
      step.comparedValue = getPercent(comparedValue);
    }

    reference = current;

    return step;
  });
};
